/**
 * Flattens a screen's label/value entries into the rows SolarSummaryCard
 * draws, keeping only rows whose label and value are both present. A present
 * label with an empty value (an absent location, a missing booking reference)
 * is dropped rather than drawn blank.
 */
export const buildCardRows = (entries = []) =>
  entries.filter((entry) => Boolean(entry?.label) && Boolean(entry?.value));

/**
 * Merges per-form Capture copy over the file copy for one screen block, so a
 * key Capture sends wins and a key it omits falls back to the file label. A
 * form with no Capture copy renders exactly the file labels.
 */
export const mergeScreenCopy = (fileBlock = {}, captureBlock = {}) => ({
  ...fileBlock,
  ...captureBlock,
});
